// Generated by ReScript, PLEASE EDIT WITH CARE


var base_fare_limit = 3000.0;

var free_duration_limit = 300;

var waiting_rate_per_min_limit = 25.0;

var free_kms_limit = 20;

var free_km_price_lmit = 25.0;

var max_number_of_slabs = 8;

var max_end_distance = 9999;

var last_slab_upper_limit = 1000000;

var slab_price_per_min_limit = 25.0;

var slab_price_per_km_limit = 100.0;

export {
  base_fare_limit ,
  free_duration_limit ,
  waiting_rate_per_min_limit ,
  free_kms_limit ,
  free_km_price_lmit ,
  max_number_of_slabs ,
  max_end_distance ,
  last_slab_upper_limit ,
  slab_price_per_min_limit ,
  slab_price_per_km_limit ,
  
}
/* No side effect */
